import { createRouter, createWebHistory } from 'vue-router'
import GoalGambitGame from '@/views/GoalGambitGame.vue'
import { PRODUCT_ID } from '@/config'
import { getStoredMsisdn, handleMyBundleEntry, isMyBundleEntry } from '@/functions/myBundleEntry'

// The MTN DOI page IS our OTP / subscription flow. A visitor with no msisdn in
// the URL is not subscribed yet, so we hand them straight to DOI; it sends them
// back with ?msisdn=... which is how they "log in" and start playing.
const DOI_LANDER = 'http://doi.mtndep.co.za/service/10856?rid=9a4cd1a05ea011f1b81e636c78ac794d'

const routes = [
  // The game is the only page — render it for every path.
  { path: '/:pathMatch(.*)*', name: 'GoalGambit', component: GoalGambitGame },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (isMyBundleEntry()) {
    const entry = await handleMyBundleEntry(PRODUCT_ID)
    if (!entry.entered) {
      window.location.replace(DOI_LANDER)
      return
    }
    return next()
  }

  const msisdn = new URLSearchParams(window.location.search).get('msisdn') || getStoredMsisdn()
  if (!msisdn) {
    // Not logged in -> straight to the DOI (OTP/subscription) flow.
    window.location.replace(DOI_LANDER)
    return
  }
  next()
})

export default router
